export default __webpack_public_path__ + "21036bbe3b4550335de46a08f445a3df.png";